import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createTag } from '../../api/tagApi';
import Select, { ActionMeta, SingleValue } from 'react-select';
import { createOption, Option } from '../../utils';
import { getSites } from '../../api/siteApi';
interface AddModalProps {
    isOpen: boolean;
    toggle: () => void;
}

const AddTagModal = ({ isOpen, toggle }: AddModalProps) => {
    const [loading, setLoading] = useState(false);
    const [sites, setSites] = useState<any>([]);
    const [selectSiteValue, setSelectSiteValue] = useState<SingleValue<Option>>();
    const validationSchema = Yup.object({
        name: Yup.string().trim().required('O nome é obrigatório'),
        siteId: Yup.number().required('O site é obrigatório'),
        domain: Yup.string()
            .trim()
            .required('O domínio é obrigatório')
            .matches(
                /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,}$/,
                'Informe um hostname válido'
            ),
    });

    const selectSiteOnChange = (newValue: SingleValue<Option>, actionMeta: ActionMeta<Option>) => {
        setSelectSiteValue(newValue);
        handleForm.setFieldValue('siteId', newValue ? Number(newValue.value) : '');
    };

    useEffect(() => {
        getSites().then(setSites);
    }, []);

    const handleForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: '',
            siteId: '',
            domain: '',
        },
        validationSchema,
        onSubmit: async (values: any) => {
            setLoading(true);
            try {
                const res = await createTag(values);
                toast.success('TAG cadastrada com sucesso!');
                toggle();
                handleForm.resetForm();
                window.location.href = '/tag/' + res.id;
            } catch (error) {
                throw error;
            } finally {
                setLoading(false);
            }
        }
    });

    return (
        <div className={`modal ${isOpen ? 'show d-block' : ''}`} id="showModal" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleForm.handleSubmit();
                        return false;
                    }}>
                        <div className="modal-header bg-light p-3">
                            <h5 className="modal-title">Nova TAG</h5>
                            <button type="button" className="btn-close" onClick={toggle} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className={'row'}>
                                <div className={'col'}>
                                    <div className="mb-3">
                                        <label
                                            htmlFor="siteId"
                                            className="form-label"
                                        >
                                            Sites
                                        </label>
                                        <Select
                                            isClearable={true}
                                            isSearchable={true}
                                            name="siteId"
                                            options={sites && sites.reduce((acc: any[], site: any) => {
                                                const publisherName = site.publisher.name;
                                                let group = acc.find((g: any) => g.label === publisherName);

                                                if (!group) {
                                                    group = { label: publisherName, options: [] };
                                                    acc.push(group);
                                                }

                                                const label = site.site ?? site.app;
                                                group.options.push(createOption(label, String(site.id)));

                                                return acc;
                                            }, [])}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderColor: !!(handleForm.touched.siteId && handleForm.errors.siteId) ? 'red' : '#ced4da',
                                                }),
                                            }}
                                            onChange={selectSiteOnChange}
                                            value={selectSiteValue}
                                        />
                                        {handleForm.touched.siteId && handleForm.errors.siteId ? (
                                            <div className="invalid-feedback d-block">{handleForm.errors.siteId}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-6'>
                                    <div className="form-group">
                                        <label htmlFor="domain" className="form-label">Site <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            id="domain"
                                            name="domain"
                                            className={`form-control ${handleForm.touched.domain && handleForm.errors.domain ? 'error' : ''}`}
                                            onChange={handleForm.handleChange}
                                            onBlur={handleForm.handleBlur}
                                            value={handleForm.values.domain}
                                            placeholder="exemplo.com.br"
                                        />
                                        {handleForm.touched.domain && handleForm.errors.domain ? (
                                            <div className="invalid-feedback d-block">{handleForm.errors.domain}</div>
                                        ) : null}
                                    </div>
                                </div>

                                <div className='col-6'>
                                    <div className="form-group">
                                        <label htmlFor="name" className="form-label">Nome da Tag <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className={`form-control ${handleForm.touched.name && handleForm.errors.name ? 'error' : ''}`}
                                            onChange={handleForm.handleChange}
                                            onBlur={handleForm.handleBlur}
                                            value={handleForm.values.name}
                                            placeholder="ROS"
                                        />
                                        {handleForm.touched.name && handleForm.errors.name ? (
                                            <div className="invalid-feedback d-block">{handleForm.errors.name}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={toggle} disabled={loading}>
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? 'Salvando...' : 'Salvar'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddTagModal;
